console.log('custom.js loaded');

const lazyLoadVideos = () => {
    const videos = document.querySelectorAll('.video_lazy');
    videos.forEach(video => {
        const sources = video.querySelectorAll('source[data-src]');
        sources.forEach(source => {
            const dataSrc = source.getAttribute('data-src');
            if (dataSrc) {
                source.src = dataSrc;
                source.removeAttribute('data-src');
            }
        });
        video.classList.remove('video_lazy');
        video.load();
    });
};

const lazyLoadImages = () => {
    const images = document.querySelectorAll('.image_lazy');
    images.forEach(image => {
        const dataSrc = image.getAttribute('data-src');
        if (dataSrc) {
            image.src = dataSrc;
            image.removeAttribute('data-src');
            image.classList.remove('image_lazy');
        }
    });
};

const initLazyLoad = () => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadVideos();
            lazyLoadImages();
        });
    } else {
        lazyLoadVideos();
        lazyLoadImages();
    }
};

initLazyLoad();
